import { create } from 'zustand';
import { mapperToSignedContracts } from '../../modules/orders/contract/mapper';
import { signedContractRepository } from '../../modules/orders/contract/repository/signedContract.repository';
import { SignedContract } from '../../modules/orders/contract/signed-contract';

export type SignedContractsState = {
  signedContracts: SignedContract[];
  loadSignedContracts: (orderId: string, callback?: () => void) => Promise<void>;
  reset: () => void;
};

export const useSignedContractsStore = create<SignedContractsState>((set) => ({
  signedContracts: [],

  loadSignedContracts: async (orderId, callback?) => {
    const response = await signedContractRepository().getSignedContracts(orderId);

    if (response.ok) {
      set({ signedContracts: mapperToSignedContracts(response.data) });
    }

    if (callback) {
      callback();
    }
  },

  reset: () => {
    set({ signedContracts: [] });
  },
}));

const signedContractsStore = {
  get signedContracts() {
    return useSignedContractsStore.getState().signedContracts;
  },
  loadSignedContracts: (orderId: string, callback?: () => void) =>
    useSignedContractsStore.getState().loadSignedContracts(orderId, callback),
  reset: () => useSignedContractsStore.getState().reset(),
};

export default signedContractsStore;
